import mycarsSrpVdp from './utils/mycarsSrpVdp';

const handleWindowSticker = ({ year, make, model }) => {
	const vehicle = window.digitaldata?.vehicle || {};
	const nameplate = `${make} ${model}`;
	vehicle.modelYear = year;
	vehicle.nameplate = nameplate;

	const payload = {
		onclick: {
			onclick: `{inventoryType}:si:vls:view window sticker:${nameplate}`,
			onclickLinkName: `{client}{inventoryType}:si:vls:view window sticker:${nameplate}`
		},
		page: {
			tool: 'event:window sticker',
			toolDescriptor: 'vls:window sticker'
		},
		event: {
			action: 'window sticker|tool'
		},
		vehicle
	};

	return {
		directCall: 'window-sticker',
		payload
	};
};

export default {
	events: {
		widgetUserEvent: [
			...mycarsSrpVdp.widgetUserEvent,
			{
				logic: ({ eventData }) => {
					const { action, result } = eventData;

					return (
						action === 'clicked' &&
						result === 'Results updated with sort selection'
					);
				},
				payload: () => {
					const payload = {
						onclick: {
							onclick:
								// according to legacy code, 'sort by' is not followed by anything
								'{inventoryType}:si:vls:content:sort by',
							onclickLinkName:
								'{inventoryType}:si:vls:content:action:{nameplate}'
						}
					};

					return {
						directCall: 'global-onclick',
						payload
					};
				}
			},
			{
				logic: ({ eventData: { isWindowStickerLink } }) =>
					isWindowStickerLink,
				payload: ({ eventData: { vehicle } }) => {
					return handleWindowSticker(vehicle);
				}
			}
		],
		thirdPartyUserEvent: [
			{
				logic: ({ eventData: { product } }) =>
					product === 'ford-prequalify-click-to-action',
				payload: ({ eventData: { vehicleUuid } }) => {
					const { modelYear, make, model } =
						window.DDC.dataLayer.vehicles.find(
							({ uuid }) => uuid === vehicleUuid
						);

					const nameplate = `${make} ${model}`;
					return {
						directCall: 'global-onclick',
						payload: {
							onclick: {
								onclick:
									'{inventoryType}:si:vls:get prequalified',
								onclickLinkName:
									'{client}{inventoryType}:si:vls:get prequalified'
							},
							page: {
								hierarchy: `shopping tools:search inventory-vls:{inventoryType}:${nameplate}`,
								pageName: `{client}{inventoryType}:si:vls:${nameplate}`
							},
							vehicle: {
								modelYear,
								nameplate
							}
						}
					};
				}
			}
		],
		'ddc.inventory.filterSearch.click': [
			{
				logic: { mustExist: '[[eventData.facets]]' },
				payload: ({ eventData: { clickedFacetName } }) => {
					return {
						directCall:
							clickedFacetName === 'model'
								? 'si-model-select'
								: 'global-onclick',
						payload: {
							onclick: {
								onclick:
									'{inventoryType}:si:vls:content:filter:[[eventData.clickedFacetName]]',
								onclickLinkName:
									'{client}{inventoryType}:si:vls:content:action:{nameplate}'
							}
						}
					};
				}
			}
		],
		'ddc.link.generic': [
			{
				logic: ({ eventData: { url, attributes } }) =>
					(url ===
						'https://window-sticker-services.pse.dealer.com/windowsticker/' ||
						url.includes('windowsticker') ||
						url.includes('windowSticker')) &&
					!attributes?.class.includes('window-sticker-link'),
				payload: ({ eventData: { vehicle } }) => {
					return handleWindowSticker(vehicle);
				}
			}
		]
	}
};
